import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor() { }
randomId() {
    return Math.random().toString(36).substr(2, 9);
  }
  
}
